// import "@fontsource/poppins"
import './src/styles/global.css'
import React from 'react';
import { ParallaxProvider } from 'react-scroll-parallax';
import '@fontsource/poppins/100.css';
import '@fontsource/poppins/200.css';
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import '@fontsource/poppins/800.css';
import '@fontsource/poppins/900.css';
import * as amplitude from '@amplitude/analytics-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';
import { ClerkProvider } from '@clerk/clerk-react'
// import { Experiment } from '@amplitude/experiment-js-client';

// Import your Publishable Key
const PUBLISHABLE_KEY = process.env.GATSBY_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  throw new Error('Add your Clerk Publishable Key to the .env file')
}

export const onClientEntry = () => {
	// if (window?.location?.hostname !== 'localhost' && window?.location?.hostname.indexOf('vercel.app') === -1) {
	// if (window?.location?.hostname !== 'localhost' && window?.location?.hostname.indexOf('vercel.app') === -1) {

		 // Create and Install Session Replay Plugin
		 const sessionReplayTracking = sessionReplayPlugin({
			sampleRate: 0.05,
			serverZone: "EU",
		   });
		amplitude.add(sessionReplayTracking);
		
		amplitude.init('6703c5544703f86f85412218af52876f', {"serverZone":"EU","autocapture":{"elementInteractions":true}});
		
	// }

}

export  const onRouteUpdate = async ({ location, prevLocation }) => {
	const params = new URLSearchParams(location.search);
	const mailchimpUser = params.get('mc_u');
	const mailchimpCampaign = params.get('mc_c');
  const affiliateCode = params.get('aff');

	if (mailchimpUser?.length > 0) {
		amplitude.setUserId(mailchimpUser);
	}

	if (mailchimpCampaign?.length > 0) {
		const event = {
      event_type: 'Mailchimp Campaign',
      event_properties: {
        campaignId: mailchimpCampaign,
      },
    };
    amplitude.track(event);
  }
  
  if (affiliateCode?.length > 0) {
    const event = {
      event_type: 'Affiliate Code',
      event_properties: {
        code: affiliateCode,
      },
    };
    amplitude.track(event);
  }

}

export const wrapRootElement = ({ element }) => {
	return (
      <ParallaxProvider>
        {element}
      </ParallaxProvider>
	);
}

export const wrapPageElement = ({ element, props }) => {
  // if (typeof window !== 'undefined') {

  let clerkSsrState;
  if (props?.serverData?.clerkState) {
    clerkSsrState = props.serverData.clerkState;
    delete props.serverData.clerkState;
  }

  return (
    <ClerkProvider 
      publishableKey={PUBLISHABLE_KEY} 
      clerkState={clerkSsrState || {}} 
      afterSignOutUrl="" 
      touchSession={false}
      allowedRedirectOrigins={['https://www.theinformationlab.com', 'https://www-local.theinformationlab.com']}
    >
      {element}
    </ClerkProvider>
  );
  
  // }
  // return element;
};


// export const experiment = Experiment.initializeWithAmplitudeAnalytics(
// 	'client-6n5cBLo4IwEfwYWNVBGmJQxdMiRfdwnY'
// );